import { render } from "./OrgConnectManagement.vue?vue&type=template&id=72598bf4&scoped=true"
import script from "./OrgConnectManagement.vue?vue&type=script&lang=js"
export * from "./OrgConnectManagement.vue?vue&type=script&lang=js"

import "./OrgConnectManagement.vue?vue&type=style&index=0&id=72598bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72598bf4"]])

export default __exports__